import { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const EntitlementContext = createContext(null);

export function EntitlementProvider({ children }) {
  const { user } = useAuth();
  const [ent, setEnt] = useState({ active: false, expires_at: null, source: null, loading: true });

  const refresh = useCallback(async () => {
    if (!user) return setEnt({ active: false, expires_at: null, source: null, loading: false });
    try {
      const { data } = await api.get("/entitlement");
      setEnt({ ...data, loading: false });
    } catch {
      setEnt({ active: false, expires_at: null, source: null, loading: false });
    }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const value = useMemo(() => ({ ...ent, refresh }), [ent, refresh]);
  return <EntitlementContext.Provider value={value}>{children}</EntitlementContext.Provider>;
}

export const useEntitlement = () => useContext(EntitlementContext);
